import { useState, useEffect, useMemo } from "react";
import { ChatClient, UserInfo } from "@2stand-events/chat-client";
import {
  Chat as ReactChat,
  Channel,
  ChannelList,
  Header,
  MessageInput,
  MessageList,
  Window,
} from "@2stand-events/chat-client-react";
import styled from "styled-components";
import { media } from "../../../theme";
import EmojiCss from "./EmojiCss";

interface Props {
  user: UserInfo;
  availableUsers: Record<string, UserInfo>;
  chatUrl: string;
  showReactions: boolean;
  showReplies: boolean;
  showImagePreview: boolean;
  storageUrl: string;
}
const Chat: React.FC<Props> = ({
  user,
  availableUsers,
  chatUrl,
  showReactions,
  showReplies,
  showImagePreview,
  storageUrl,
}) => {
  const [client, setClient] = useState<ChatClient>();
  useEffect(() => {
    const client = new ChatClient(chatUrl);
    setClient(client);
    const token = sessionStorage.getItem("current-user-token");

    client.connectUser(user, token);

    return () => client?.closeConnection();
  }, [user]);

  const users = useMemo(() => {
    return new Map<string, UserInfo>(Object.entries(availableUsers));
  }, [availableUsers]);

  return (
    <EmojiCss>
      <Container>
        <ReactChat
          client={client}
          theme="light"
          showReactions={showReactions}
          showReplies={showReplies}
          showImagePreview={showImagePreview}
          storageUrl={storageUrl}
        >
          <ChannelList users={users}>
            <Channel>
              <Window>
                <Header />
                <MessageList />
                <MessageInput />
              </Window>
            </Channel>
          </ChannelList>
        </ReactChat>
      </Container>
    </EmojiCss>
  );
};

const Container = styled.div`
  display: grid;
  font-family: var(--font-family);
  background: #f2f2f2;
  width: auto;

  min-height: calc(100vh - 169px);
  max-height: calc(100vh - 169px);
  height: 0;
  textarea {
    font-family: inherit !important;
  }
  ${media.medium} {
    max-height: calc(100vh - 435px);
  }
  max-width: 1980px;
  margin: 0 auto;
`;

export default Chat;
